import { render, staticRenderFns } from "./paymentAllocationSummary.vue?vue&type=template&id=e604c01a&"
import script from "./paymentAllocationSummary.vue?vue&type=script&lang=js&"
export * from "./paymentAllocationSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports